import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { StateStatus } from '@guryou/redux';
import { resetState } from '../actions';
import { SERVICE_GROUPS_GET_MANY } from '../new';
import { getMemberships, MEMBERSHIP_DELETE, MEMBERSHIP_PUBLISHED, MEMBERSHIP_REORDER, PROVIDER_MEMBERSHIPS, SAVE_MEMBERSHIP } from '../new/membership';
const useMemberships = function () {
  let {
    membershipId,
    groupId
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const dispatch = useDispatch();
  const {
    data,
    status,
    version,
    entity
  } = useSelector(state => state.membership.all);
  const saveMembership = useSelector(state => state.membership.save);
  const deleteMembership = useSelector(state => state.membership.delete);
  const reorderMembership = useSelector(state => state.membership.reorder);
  const statusMembership = useSelector(state => state.membership.status);
  useEffect(() => {
    if (status === StateStatus.LOADING) {
      return;
    }
    if (status === StateStatus.NOT_INITIALIZED) {
      dispatch(getMemberships(saveMembership.version || deleteMembership.version || reorderMembership.version, groupId));
      return;
    }
    if (reorderMembership.version || statusMembership.version) {
      dispatch(getMemberships(true, groupId));
      statusMembership.version && dispatch(resetState(MEMBERSHIP_PUBLISHED));
      reorderMembership.version && dispatch(resetState(MEMBERSHIP_REORDER));
    }
    if (saveMembership.version || deleteMembership.version) {
      dispatch(resetState(PROVIDER_MEMBERSHIPS));
      dispatch(resetState(SERVICE_GROUPS_GET_MANY));
      saveMembership.version && dispatch(resetState(SAVE_MEMBERSHIP));
      deleteMembership.version && dispatch(resetState(MEMBERSHIP_DELETE));
    }
  }, [data, deleteMembership.version, dispatch, reorderMembership.version, saveMembership.version, status, statusMembership.version, groupId]);
  if (membershipId) {
    return {
      membership: (data || []).find(x => x.id === membershipId),
      status,
      version,
      entity
    };
  }
  return {
    data: data || [],
    status,
    version,
    entity
  };
};
export default useMemberships;